export const providerWebhookEvents = [
  { key: 'campaign.sold', label: 'Campaign Sold' },
  { key: 'campaign.updated', label: 'Campaign Updated' },
  { key: 'order.approved', label: 'Order Approved' },
  { key: 'order.deleted', label: 'Order Deleted' },
  { key: 'order.unapproved', label: 'Order Unapproved' },
  { key: 'order_item.deleted', label: 'Order Item Deleted' },
  { key: 'publication_booking.approved', label: 'Publication Booking Approved' },
  { key: 'publication_booking.unapproved', label: 'Publication Booking Unapproved' },
  { key: 'publication_order.created', label: 'Publication Order Created' },
  { key: 'publication_order.reverted', label: 'Publication Order Reverted' },
  { key: 'task.approved', label: 'Task Approved' },
  { key: 'task.deleted', label: 'Task Deleted' },
  { key: 'task.updated', label: 'Task Updated' },
]

export const systemWebhookEvents = [
  { key: 'agency.created', label: 'Agency Created' },
  { key: 'agency.updated', label: 'Agency Updated' },
  { key: 'brand.created', label: 'Brand Created' },
  { key: 'brand.updated', label: 'Brand Updated' },
  { key: 'campaign.created', label: 'Campaign Created' },
  { key: 'campaign.updated', label: 'Campaign Updated' },
  { key: 'campaign_proposal.created', label: 'Proposal Created' },
  { key: 'campaign_proposal.updated', label: 'Proposal Updated' },
  { key: 'template_page.deleted', label: 'Template Page Archived' },
  { key: 'template_page.duplicated', label: 'Template Page Duplicated' },
  { key: 'user.created', label: 'User Created' },
  { key: 'user.updated', label: 'User Updated' },
]

export default providerWebhookEvents
